// extracted by mini-css-extract-plugin
export var aggregationCell = "_2r-p";
export var aggregationRow = "_2r-o";
export var borderlessSpinnerContainer = "_2r-3";
export var cardLayout = "_2r-6";
export var cardLayoutNoFooter = "_2r-a";
export var cardLayoutPageControl = "_2r-9";
export var cardLayoutWithFooter = "_2r-8";
export var closeIcon = "_2r-h";
export var columnHeaderSurface = "_2r-d";
export var columnHeaderSurfaceDragOverlay = "_2r-x";
export var columnHeaderSurfaceResizing = "_2r-u";
export var contextMenuAnchor = "_2r-1";
export var draggableColumnHeader = "_2r-v";
export var draggableColumnHeaderOverlay = "_2r-w";
export var expandIcon = "_2r-i";
export var expanded = "_2r-j";
export var filterDropdown = "_2r-k";
export var filterDropdownDivider = "_2r-f";
export var filterDropdownHeader = "_2r-n";
export var filterDropdownItem = "_2r-m";
export var filterDropdownModal = "_2r-l _2r-k";
export var filterItem = "_2r-e";
export var normalCellWithAdjustableBorder = "_2r-g";
export var pinButtonContainer = "_2r-q";
export var pinIcon = "_2r-r";
export var pinIconActive = "_2r-s";
export var spinner = "_2r-0";
export var spinnerContainer = "_2r-2";
export var tableContainer = "_2r-4";
export var tableContentDraggingColumns = "_2r-c";
export var tableContentInner = "_2r-7";
export var tableContentInnerFill = "_2r-b";
export var tableContentWrapper = "_2r-5";
export var viewButtonContainer = "_2r-t";